import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    staticVersionNumber: '2.5',
    version: null,
    jwtToken: null,
    userSub: null,
    isLoggedIn: false,
    wallet: null,
    showSlideMenu: '',
    connectionId: null,
    updatingWalletCredits: 0,
    updatingWalletHoneyPoints: 0,
    creatingEntry: 0,
    updatingEntry: 0,
    creatingPaymentRequest: 0,
    updatingPaymentRequest: 0,
    selectedCupId: null,
    acceptedCookies: null,
    viewedCookiesPopup: null,
    redirectLink: null,
    updatingUser: 0,
    noSubmitRatingCount: 0,
    displayNoSubmitDialog: false,
    hideYellowBar: false
  },
  getters: {
    version (state) {
      return state.version;
    },
    staticVersionNumber (state) {
      return state.staticVersionNumber;
    },
    jwtToken (state) {
      return state.jwtToken;
    },
    showSlideMenu (state) {
      return state.showSlideMenu;
    },
    isLoggedIn (state) {
      return state.isLoggedIn;
    },
    userSub (state) {
      return state.userSub;
    },
    wallet (state) {
      return state.wallet;
    },
    connectionId (state) {
      return state.connectionId;
    },
    updatingWalletCredits (state) {
      return state.updatingWalletCredits;
    },
    updatingWalletHoneyPoints (state) {
      return state.updatingWalletHoneyPoints;
    },
    creatingEntry (state) {
      return state.creatingEntry;
    },
    updatingEntry (state) {
      return state.updatingEntry;
    },
    creatingPaymentRequest (state) {
      return state.creatingPaymentRequest;
    },
    updatingPaymentRequest (state) {
      return state.updatingPaymentRequest;
    },
    selectedCupId (state) {
      return state.selectedCupId;
    },
    acceptedCookies (state) {
      return state.acceptedCookies;
    },
    viewedCookiesPopup (state) {
      return state.viewedCookiesPopup;
    },
    redirectLink (state) {
      return state.redirectLink;
    },
    updatingUser(state){
      return state.updatingUser;
    },
    payReturnUrl(){
      return process.env.VUE_APP_PAY_RETURN_URL;
    },
    noSubmitRatingCount(state){
      return state.noSubmitRatingCount;
    },
    displayNoSubmitDialog(state){
      return state.displayNoSubmitDialog
    },
    tpSiteId(){
      return process.env.VUE_APP_TP_SITE_ID;
    },
    hideYellowBar (state) {
      return state.hideYellowBar;
    }
  },
  mutations: {
    setVersion (state, version) {
      state.version = version;
    },
    setJwtToken (state, jwtToken) {
      state.jwtToken = jwtToken;
    },
    setUserSub (state, userSub) {
      state.userSub = userSub;
    },
    setIsLoggedIn (state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setWallet (state, wallet) {
      state.wallet = wallet;
    },
    setShowSlideMenu (state, showSlideMenu) {
      state.showSlideMenu = showSlideMenu;
    },
    setConnectionId (state, connectionId) {
      state.connectionId = connectionId;
    },
    setUpdatingWalletCredits (state, updatingWalletCredits) {
      state.updatingWalletCredits = updatingWalletCredits;
    },
    setUpdatingWalletHoneyPoints (state, updatingWalletHoneyPoints) {
      state.updatingWalletHoneyPoints = updatingWalletHoneyPoints;
    },
    setCreatingEntry (state, creatingEntry) {
      state.creatingEntry = creatingEntry;
    },
    setUpdatingEntry (state, updatingEntry) {
      state.updatingEntry = updatingEntry;
    },
    setCreatingPaymentRequest (state, creatingPaymentRequest) {
      state.creatingPaymentRequest = creatingPaymentRequest;
    },
    setUpdatingPaymentRequest (state, updatingPaymentRequest) {
      state.updatingPaymentRequest = updatingPaymentRequest;
    },
    setSelectedCupId (state, selectedCupId) {
      state.selectedCupId = selectedCupId;
    },
    setAcceptedCookies (state, val) {
      state.acceptedCookies = val;
    },
    setViewedCookiesPopup (state, val) {
      state.viewedCookiesPopup = val;
    },
    setRedirectLink (state, val) {
      state.redirectLink = val;
    },
    setUpdatingUser (state, updatingUser) {
      state.updatingUser = updatingUser;
    },
    setNoSubmitRatingCount (state, noSubmitRatingCount) {
      state.noSubmitRatingCount = noSubmitRatingCount;
    },
    setDisplayNoSubmitDialog (state, displayNoSubmitDialog) {
      state.displayNoSubmitDialog = displayNoSubmitDialog;
    },
    setHideYellowBar (state, hideYellowBar) {
      state.hideYellowBar = hideYellowBar;
    }
  },
  actions: {
    getVersion(context) {
      return new Promise((resolve, reject) => {
        console.log(process.env.VUE_APP_API);
        axios.get(`${process.env.VUE_APP_API}/versions/6ce0f5d0-de0f-42ea-99d6-52078af3077c`, {
            headers: {
              Authorization: context.getters.jwtToken
            }
          })
          .then(function (response) {
            context.commit('setVersion', response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },
    getServerTime(context) {
      return new Promise((resolve, reject) => {
        console.log(process.env.VUE_APP_API);
        axios.get('https://fhic3vrrln57gwlcf74mscfrma0qtkhj.lambda-url.eu-west-2.on.aws', {
            headers: {
              Authorization: context.getters.jwtToken
            }
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },
    getCompetition(context, competitionId) {
      return new Promise((resolve, reject) => {
        console.log(process.env.VUE_APP_API);
        axios.get(`${process.env.VUE_APP_API}/competitions/${competitionId}`, {
            headers: {
              Authorization: context.getters.jwtToken
            }
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },
    getCompetitions(context, where) {
      return new Promise((resolve, reject) => {
        console.log(process.env.VUE_APP_API);
        axios.get(`${process.env.VUE_APP_API}/competitions${where}`, {
            headers: {
              Authorization: context.getters.jwtToken
            }
          })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },
    getWallet(context, userId) {
      return new Promise((resolve, reject) => {        
        axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/wallets?userId=' + userId, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data[0]);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    addWalletTransaction(context, walletTransaction) {
      return new Promise((resolve, reject) => {        
        axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/wallet-transactions', 
        walletTransaction,
        {
          headers: {
            Authorization: context.getters.jwtToken,
            connectionid: context.getters.connectionId
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    addEntry(context, entry) {
      return new Promise((resolve, reject) => {        
        axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries', 
        entry,
        {
          headers: {
            Authorization: context.getters.jwtToken,
            connectionid: context.getters.connectionId
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    addHoneyTransaction(context, honeyTransaction) {
      return new Promise((resolve, reject) => {        
        axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/honey-transactions', 
        honeyTransaction,
        {
          headers: {
            Authorization: context.getters.jwtToken,
            connectionid: context.getters.connectionId
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    getEntry(context, entryId) {
      return new Promise((resolve, reject) => {        
        axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries/' + entryId, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error.response);
          });

      });
    },
    getEntries(context) {
      return new Promise((resolve, reject) => {     
        
        var sortFilter = "sortBy=name&sortByDirection=asc"
        var filter = "?" + sortFilter;
        if (context.state.userSub.role === "user")
          filter = filter + "&userId=" + context.state.userSub.id;
        if (context.state.role === "clubadmin")
          filter = filter + "&clubId=" + context.state.adminClubId;
        
        axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries' + filter, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getTransactions(context) {
      return new Promise((resolve, reject) => {     
        
        var sortFilter = "sortBy=date_created&sortByDirection=desc"
        var filter = "?" + sortFilter;
        if (context.state.userSub.role === "user")
          filter = filter + "&userId=" + context.state.userSub.id;
        if (context.state.userSub.role === "clubadmin")
          filter = filter + "&clubId=" + context.state.userSub.adminClubId;

        axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/wallet-transactions' + filter, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getHoneyPoints(context) {
      return new Promise((resolve, reject) => {     
        
        var sortFilter = "sortBy=date_created&sortByDirection=desc"
        var filter = "?" + sortFilter;
        if (context.state.userSub.role === "user")
          filter = filter + "&userId=" + context.state.userSub.id;
        if (context.state.userSub.role === "clubadmin")
          filter = filter + "&clubId=" + context.state.userSub.adminClubId;

        axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/honey-transactions' + filter, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getQuestions(context, filter) {
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/questions?random=${filter.sportId}&limit=${filter.totalQuestions}&`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getMatchPlayers(context, matchId) {
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/match-players?matchId=${matchId}`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getEntryQuestionAnswers(context, entryId) {
      var sortFilter = `entryId=${entryId}&sortBy=question_number&sortByDirection=asc`
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entry-question-answers?${sortFilter}`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getCustom(context, slugParams) {
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/custom?slug=${slugParams.slug}${slugParams.params}`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getUser(context, userId) {
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/users/${userId}`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    updateUser(context, user) {
      return new Promise((resolve, reject) => {        
        axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/users/${user.id}`, 
        user,
        {
          headers: {
            Authorization: context.getters.jwtToken,
            connectionid: context.getters.connectionId
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    addPaymentRequest(context, paymentRequest) {
      return new Promise((resolve, reject) => {        
        axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/payment-requests',
        paymentRequest,
        {
          headers: {
            Authorization: context.getters.jwtToken,
            connectionid: context.getters.connectionId
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    updatePaymentRequest(context, paymentRequest) {
      return new Promise((resolve, reject) => {        
        axios.put(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/payment-requests/${paymentRequest.id}`,
        paymentRequest,
        {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
    getPaymentRequest(context, paymentRequestId) {
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/payment-requests/${paymentRequestId}`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    addInternal(context, internal) {
      return new Promise((resolve, reject) => {        
        axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/internals', 
        internal,
        {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },
    getHasEntered(context, getHasEnteredRequest) {
      var sortFilter = `userId=${getHasEnteredRequest.userId}&competitionId=${getHasEnteredRequest.competitionId}`
      return new Promise((resolve, reject) => {     
        axios.get(`https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/entries?${sortFilter}`, {
          headers: {
            Authorization: context.getters.jwtToken
          }
        })
          .then(function (response) {
            resolve(response.data);
          })
          .catch(function (error) {
            reject(error);
          });

      });
    },
  }
})

export default store;
